
import Button from "@/components/base/Button"
import { mdiChevronDown, mdiChevronUp } from "@mdi/js"

export default {
    name: "BusinessInfo",
    components: { Button },
    props: {
        business: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        mdiChevronUp,
        mdiChevronDown,
        showMore: false,
    }),
}
